
import axios from 'axios'
import type { ProductionStats, Statistics, StatisticsQuery } from 'BrokerTsLib/src/dtos'
import { Product } from 'BrokerTsLib/src/enums'
import { useMutation } from 'react-query'
import { useApp } from './useApp'

export const baseUrl = import.meta.env.VITE_BASE_URL
const apiVehicleUrl = import.meta.env.VITE_STATISTICS_VEHICLE_API
const apiTravelUrl = import.meta.env.VITE_STATISTICS_TRAVEL_API
const apiPropertyUrl = import.meta.env.VITE_STATISTICS_PROPERTY_API


export const useUrl = () => {
  const { product } = useApp()

  let url: string | undefined = ''

  switch (product) {
    case Product.TravelInsurance: url = apiTravelUrl; break
    case Product.PropertyInsurance: url = apiPropertyUrl; break
    default: url = apiVehicleUrl; break
  }

  return `${baseUrl}/${url}`
}

export const useGetStatistics = () => {
  const url = useUrl()

  return useMutation((search: StatisticsQuery) =>
    axios.post<Statistics>(`${url}/GetStatistics`, search))
}

export const useGetProductionStatistics = () => {
  const url = useUrl()

  return useMutation((search: StatisticsQuery) =>
    axios.post<ProductionStats>(`${url}/GetProductionStatistics`, search))
}